import { render, staticRenderFns } from "./SelectedDinamicField.vue?vue&type=template&id=2c8911de&"
import script from "./SelectedDinamicField.vue?vue&type=script&lang=js&"
export * from "./SelectedDinamicField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports